"use es6";

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = v => /^\x2D?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)$/.test(v);
export { isNumericalString };